import styled from 'styled-components';

import colors from '../../../../styles/colors';
import Modal from '../../../../components/v2/Modal';
import Button from '../../../../components/Button';

const StyledModal = styled(Modal)`
  && {
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding-bottom: 30px;
`;

const AddSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${colors.shades.gamma4};
`;

const AddRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const AddButton = styled(Button)`
  white-space: nowrap;
  margin: 0;
`;

const RosterCount = styled.div`
  font-weight: 500;
  font-size: 15px;
`;

const OptionLabel = styled.div`
  display: flex;
  align-items: center;
`;

export {
  StyledModal,
  Container,
  AddSection,
  AddRow,
  AddButton,
  RosterCount,
  OptionLabel,
};
